/** Human phrasing for day counts. "0 jours" is technically right and reads like a fault. */
export function daysOnSite(days: number | null): string {
  if (days === null) return '—';
  if (days === 0) return "arrivé aujourd'hui";
  if (days === 1) return 'depuis hier';
  return `depuis ${days} jours`;
}

/** The compact form for a list row, where space is tight. */
export function daysShort(days: number | null): string {
  if (days === null) return '';
  if (days === 0) return "aujourd'hui";
  if (days === 1) return 'hier';
  return `${days} j`;
}

/**
 * How a round reads in a list.
 *
 * A correction is a round in the log — a scan has to belong to one — but calling it
 * "interrompue" alongside real sweeps misnames it: nobody interrupted anything, and nothing
 * was ever going to be concluded. One helper rather than the same branch in four screens.
 */
export interface RoundBadge {
  /** What was recorded, and under what name. */
  count: string;
  /** What became of the round. */
  status: string;
  tone: '' | 'ok' | 'warn' | 'accent';
}

export function roundBadge(r: {
  mode: 'sweep' | 'correction';
  status: 'open' | 'closed' | 'abandoned';
  scanned: readonly string[];
  missing: readonly string[];
}): RoundBadge {
  // Zéro prend le singulier : « 0 manquant », jamais « 0 manquants ».
  const plural = (n: number) => (n > 1 ? 's' : '');
  const n = r.scanned.length;
  if (r.mode === 'correction') {
    return { count: `${n} enregistré${plural(n)}`, status: 'hors tournée', tone: '' };
  }
  const count = `${n} scanné${plural(n)}`;
  if (r.status === 'closed') {
    const m = r.missing.length;
    return { count, status: `${m} manquant${plural(m)}`, tone: m > 0 ? 'warn' : 'ok' };
  }
  if (r.status === 'abandoned') return { count, status: 'interrompue', tone: '' };
  return { count, status: 'en cours', tone: 'accent' };
}
